/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Report_LinkInputs */

const en_error_report_link = /** @type {(inputs: Error_Report_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`here`)
};

const pl_error_report_link = /** @type {(inputs: Error_Report_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tutaj`)
};

/**
* | output |
* | --- |
* | "here" |
*
* @param {Error_Report_LinkInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const error_report_link = /** @type {((inputs?: Error_Report_LinkInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Report_LinkInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_error_report_link(inputs)
	return en_error_report_link(inputs)
});